import axios from 'axios';
import env from 'config/env';

/**
 * Created by Timoteo Shockness 
 * Class for handle HTTP Request
 * Using Axios Library
 */
class AxiosApi
{
    /**
     * Sets the base URL for API
     * Binds all Functions to be used outside
     * @param url String - htts://url.azurewebsite.net
     */
    constructor(url)
    {
        this.baseURL = url;
        this.instance = null;
        this.token = axios.create({
            baseURL: this.baseURL,
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        });

        this.HttpGet = this.HttpGet.bind(this);
        this.HttpPost = this.HttpPost.bind(this);
        this.HttpPatch = this.HttpPatch.bind(this);
        this.HttpPut = this.HttpPut.bind(this);
        this.HttpDelete = this.HttpDelete.bind(this);
        this.setToken = this.setToken.bind(this);
        this.getInstance = this.getInstance.bind(this);

    }

    /**
     * HTTP GET
     * @param {string} url - URL for GET request 
     */
    HttpGet(url)
    {
        return this.token.get(url);    
    }

    /**
     * HTTP DELETE
     * @param {string} url - URL for DELETE request 
     */
    HttpDelete(url)
    {
        return this.token.delete(url);    
    }

    /**
     * HTTP POST
     * @param {string} url - URL for POST request
     * @param {object} model - Object to be sent to the Server
     */
    HttpPost(url, model)
    {
        return this.token.post(url, model);
    }
    
    /**
     * HTTP PUT
     * @param {string} url - URL for POST request
     * @param {object} model - Object to be sent to the Server
     */
     HttpPut(url, model)
    {
        return this.token.put(url, model);
    }
    
     /**
     * HTTP PATCH
     * @param {string} url - URL for POST request
     * @param {object} model - Object to be sent to the Server
     */
    HttpPatch(url, model)
    {
        return this.token.patch(url, model);
    }

    /**
     * Sets the Token in the HTTP header for the auth user
     * @param {string} token - OAuth 2.0 / Bearer Token 
     */
    setToken(token)
    {
        this.token = axios.create({
            baseURL: this.baseURL,
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'timezone_offset': new Date(Date.now()).getTimezoneOffset()
            }
        });
    }

    /**
     * Destroy the Token and Create a new Axios instance without the token
     */
    flushToken()
    {
        this.token = axios.create({
            baseURL: this.baseURL,
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        });
    }

    getInstance(){
        if(this.instance == null){
            this.instance = new AxiosApi(env.baseUrl());
        }
        
        return this.instance;
        
    }
}

//exporting just a method to encapsulate the Class
export default new AxiosApi().getInstance;
